// Kept apart from app.routes.ts so guards and helpers can import the symbols without a
// circular dependency on the route table (which imports the guards).
export enum RouteSymbols {
  FormVisualGuide = 'form-visual-guide',
  CustomerLogin = 'customer-login/:campaignGuid',
  CustomerLoginPinValidation = 'pin-validation',
  CustomerLoginAddresses = 'addresses',
  CustomerFeedbackPage = 'feedback',
  ValidationComponents = 'validation-components',
  Home = '',
  Campaigns = 'campaigns',
  Campaign = ':campaignGuid',
  Companies = 'companies',
  Company = ':companyGuid',
  CompanyDashboard = 'dashboard',
  CompanyCustomers = 'customers',
  CompanyProducts = 'products',
  CompanyFinancing = 'financing',
  CompanyDocuments = 'documents',
  CompanyStyles = 'styles',
  CompanyHistory = 'history',
  CompanyEmails = 'emails',
  CompanyCustomerFeedbacks = 'customer-feedbacks',
  Dashboard = 'dashboard',
  Checkups = 'checkups/:campaignInstanceStatusId',
  CheckupsAll = 'checkups',
  CheckupOpen = 'checkups/open/:campaignInstanceGuid',
  CheckupDetail = ':campaignInstanceGuid',
  Settings = 'settings',
  SettingsGeneralData = 'general-data',
  SettingsConfiguration = 'configuration',
  SettingsCheckupConfig = 'checkup-config',
  SettingsCustomers = 'customers',
  SettingsHistory = 'history',
  SettingsBulkLoadHistory = 'bulk-load-history',
  SettingsStyles = 'styles',
  SettingsEmails = 'emails',
  SettingsCustomerFeedbacks = 'customer-feedbacks',
  SettingsEnabledZones = 'enabled-zones',
  Admin = 'admin',
  Security = 'security',
  Organizations = 'organizations',
  Positions = 'positions',
  Users = 'users',
  Features = 'features',
  DataMaintenance = 'data-maintenance',
  MasterDataTypes = 'master-data-item-types',
  MasterDataItems = 'master-data-items',
  Translations = 'translations',
  UserTrackings = 'user-trackings',
  Emails = 'emails',
  CustomerFeedbacks = 'customer-feedbacks',
  ScheduledTasks = 'scheduled-tasks',
  Versions = 'versions',
  Redirect = 'redirect',
  ErrorHTTPCode = 'error/:httpCode',
  Error404 = '/error/404',
  Logoff = 'logoff',
  NotFound = '**',
}
